import React from "react";
import MuiCardContent from "@mui/material/CardContent";
import PropTypes from "prop-types";

/**
 * CardContent component wrapper for card content area.
 * Wraps Material-UI CardContent with theme integration.
 * 
 * @component
 * @example
 * <CardContent>
 *   <Typography variant="h5">Title</Typography>
 *   <Typography variant="body2">Description</Typography>
 * </CardContent>
 */
const CardContent = ({ children, ...props }) => {
  return <MuiCardContent {...props}>{children}</MuiCardContent>;
};

CardContent.propTypes = {
  /**
   * The content of the component
   */
  children: PropTypes.node,
  /**
   * The component used for the root node
   */
  component: PropTypes.elementType,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles
   */
  sx: PropTypes.oneOfType([
    PropTypes.arrayOf(
      PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])
    ),
    PropTypes.func,
    PropTypes.object,
  ]),
};

// No defaultProps - maintain exact MUI CardContent behavior

export default CardContent;

